import type { DataTableViewCommonProps } from './data-table.interface'

export const buildDataTableViewProps = <TData>(input: DataTableViewCommonProps<TData>) => ({
  toolbar: input.toolbar,
  data: input.data,
  columnList: input.columnList,
  getRowId: input.getRowId,
  isSelectable: input.isSelectable,
  isAllSelected: input.tableState.isAllSelected,
  isIndeterminate: input.tableState.isIndeterminate,
  onSelectAll: input.tableState.handleSelectAll,
  isRowSelected: input.tableState.isRowSelected,
  onSelectRow: input.tableState.handleSelectRow,
  actionList: input.actionList,
  hasActions: input.tableState.hasActions,
  totalColSpan: input.tableState.totalColSpan,
  emptyMessage: input.emptyMessage,
  onSortChange: input.onSortChange,
  getColumnSortOrder: input.tableState.getColumnSortOrder,
  onSort: input.tableState.handleSort,
  pagination: input.pagination,
  onPageChange: input.onPageChange,
  onPageSizeChange: input.onPageSizeChange,
  className: input.className,
})
